/**
 * Download icon animation
 * Subtle continuous animation for import/download states
 * Arrow gently pulses down to suggest downloading motion
 */

@keyframes arrow-pulse {
  0%,
  100% {
    transform: translateY(0);
    opacity: 1;
  }
  50% {
    transform: translateY(1.5px);
    opacity: 0.7;
  }
}

.animated-download-svg {
  animation: arrow-pulse 1.5s ease-in-out infinite;
  transform-origin: center center;
}

@media (prefers-reduced-motion: reduce) {
  .animated-download-svg {
    animation: none;
  }
}
